import { CCol, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import {
  apiCallResponse,
  apiExportToExcel,
  apisResponseDownload,
} from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import {
  FilterContains,
  FilterContainsInsensitive,
  FilterEqual,
} from "../common/FilterCondition";

import CommonList from "../common/CommonList";
import {
  CommonSearchExtra,
  SCDate,
  SCInput,
  SCSelect,
  updateSearchStatus,
} from "../common/CommonSearch";
import TableDateFromat from "../common/Table/TableDateFromat";
import TableButtonClick from "../common/Table/TableButtonClick";

const OnlinePaymentReport = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [isExporting, setIsExporting] = useState(false); //Export To Excel Loader Manage
  const [itemsCollectionSeason, setItemsCollectionSeason] = useState([]);
  const [textField, settextField] = useState("Amount");
  const [order, setorder] = useState("asc");
  const [orderClick, setOrderClick] = useState(true);

  // Your default search model
  const SearchFilterModel = {
    CollectionSeason:  new Date().getFullYear().toString(),
    MRNO: "",
    ChallanNo: "",
    LotNo: "",
    Mobile: "",
    CompanyName: "",
    PaymentType: "",
    StartInsertDate: "",
    EndInsertDate: "",
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Model

  useEffect(() => {
    orderClick ? setorder("asc") : setorder("desc");
    setloading(true);
    resetPageLimit(0);
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getOnlinePaymentList();
      getTenderCollectionSeasonDrop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getOnlinePaymentList();
      getTenderCollectionSeasonDrop();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);
  // useEffect(() => {
  //   orderClick ? setorder("asc") : setorder("desc");
  //   getOnlinePaymentList(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage, authenticated]);

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };
  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";
debugger;
    filter = "&$filter=";
    filter = FilterContains(filter, "paymentId", search.MRNO);

    if (authenticated.role === "CFO") {
      filter = FilterContains(filter, "circleId", authenticated.district);
    }
    if (authenticated.role === "DFO") {
      filter = FilterContains(filter, "districtId", authenticated.district);
    }

filter = FilterContains(filter, "collectionSeason", search.CollectionSeason);
    filter = FilterContainsInsensitive(
      filter,
      "ChallanNumber",
      search.ChallanNo
    );
    filter = FilterContainsInsensitive(filter, "LotNo", search.LotNo);
    filter = FilterContains(filter, "Mobile", search.Mobile);
    filter = FilterContainsInsensitive(
      filter,
      "CompanyName",
      search.CompanyName
    );

    if (search.PaymentType !== "" && search.PaymentType !== undefined) {
      if (filter !== "&$filter=") {
        filter += " and ";
      }
      if (
        search.PaymentType === "--1" ||
        search.PaymentType === "--2" ||
        search.PaymentType === "--3" ||
        search.PaymentType === "--4" ||
        search.PaymentType === "--5" ||
        search.PaymentType === "--6"
      ) {
        filter += "endswith(ResponseMessage,'" + search.PaymentType + "')";
      } else if (search.PaymentType === "LT-") {
        filter +=
          "startswith(ResponseMessage,'" +
          search.PaymentType +
          "') and endswith(ResponseMessage,'--1') eq false and endswith(ResponseMessage,'--2') eq false and endswith(ResponseMessage,'--3') eq false and endswith(ResponseMessage,'--4') eq false and endswith(ResponseMessage,'--5') eq false and endswith(ResponseMessage,'--6') eq false";
      } else {
        filter += "startswith(ResponseMessage,'" + search.PaymentType + "')";
      }
    }
    if (search.StartInsertDate !== "" && search.StartInsertDate !== undefined) {
      if (filter !== "&$filter=") {
        filter += " and ";
      }
      filter += "PaymentSuccessDate ge " + search.StartInsertDate;
    }
    if (search.EndInsertDate !== "" && search.EndInsertDate !== undefined) {
      if (filter !== "&$filter=") {
        filter += " and ";
      }
      filter += "PaymentSuccessDate le " + search.EndInsertDate;
    }

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(
        `Report/getOnlinePaymentListCount?${filterManage()}`
      ).then((res) => {
        debugger;
        if (res.success) paggingDisabledManage(parseInt(res.data.length) || 0);
      }).then(data => console.log(data))
      .catch(error => console.error('Error:', error));;
    }
  };

  const getOnlinePaymentList = async (firstRequest) => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `Report/getOnlinePaymentList?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        debugger;
        if (res.success) {
          setUsersData(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingDisabledManage(pageCount);
          }
        }
        setloading(false);
      });
    }
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    debugger;
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUsersData();
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };

  // get Report List ExportToExcel
  const ExportToExcel = async () => {
    setIsExporting(true);
    try {
      await apiExportToExcel(
        pageCount,
        `Report/ExportToExcel?collectionSeason=${search.CollectionSeason}&MRNO=${search.MRNO}&ChallanNo=${search.ChallanNo}&LotNo=${search.LotNo}&Mobile=${search.Mobile}&CompanyName=${search.CompanyName}&PaymentType=${search.PaymentType}&StartInsertDate=${search.StartInsertDate}&EndInsertDate=${search.EndInsertDate}&Role=${authenticated.role}&DistId=${authenticated.district}`,
        null,
        "OnlinePaymentReport.xls",
        "GET"
      ).finally(() => {
        setIsExporting(false);
      });
    } catch (error) {
      // Handle any errors that might occur during the export process
      console.error("Error exporting to Excel:", error);
      alert("records not available");
      setIsExporting(false); // Reset isExporting state if an error occurs
    }
  };

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    // if (textField !== getTextField) {
    //   setorder("asc");
    // } else {
    //   !orderClick ? setorder("asc") : setorder("desc");
    // }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  const PaymentStatusViewHanlder = async (tranid) => {
    const url = `Report/DownloadReceipt?txnId=${tranid}`;
    const documentName = `${tranid}.pdf`;

    await apisResponseDownload(url, documentName).then((res) => {
      if (!res.success) {
        alert("Receipt not available");
      }
    });
  };
  const DisplayDate = (date) => {
    return TableDateFromat(date);
  };
  // const lotPaymentDisplay = (item) => {
  //   const InstallamentType =
  //     item.paymentComplete === "25"
  //       ? "  First Installment"
  //       : item.paymentComplete === "50"
  //       ? "Second Installemnt"
  //       : item.paymentComplete === "75"
  //       ? "Third Installment"
  //       : item.paymentComplete === "100"
  //       ? "Fourth Installment"
  //       : "";
  //   return " - " + InstallamentType;
  // };
  let scopedSlotsList = {
    inserdateformat: (item, index) => {
      return DisplayDate(item.insertDateTime);
    },
    paymentDateFormat: (item, index) => {
      return DisplayDate(item.paymentDateTime);
    },
    paymentSuccessDateFormat: (item, index) => {
      return DisplayDate(item.paymentSuccessDate);
    },
    displayPaymentType: (item, index) => {
      //const prefix = item.responseMessage.substring(0, 3);

      return (
        <td className="py-2">
          <span>
            {item.responseMessage.endsWith("--1")
              ? "Security Deposit"
              : item.responseMessage.endsWith("--2")
              ? "Full Lot Payment"
              : item.responseMessage.endsWith("--3")
              ? "Additional Security Deposit"
              : item.responseMessage.endsWith("--4")
              ? "Additional Security Deposit 40%"
              : item.responseMessage.endsWith("--5")
              ? "Additional Security Deposit 60%"
              : item.responseMessage.endsWith("--6")
              ? "Godown Qutity Differnce Amount"
              : item.responseMessage.substring(0, 3) === "LT-"
              ? "Lot Payment " //+ lotPaymentDisplay(item)
              : item.responseMessage.substring(0, 3) === "FT-"
              ? "Lot Transfer Fees"
              : item.responseMessage.substring(0, 3) === "Tra"
              ? "Security Deposit - Transferred"
              : item.responseMessage.substring(0, 3) === "GR-"
              ? "Godown Rent"
              : item.responseMessage.substring(0, 3) === "GRE"
              ? "Godown Rent Fee Extension"
              : item.responseMessage.substring(0, 3) === "LFT"
              ? "Lot Left Fee"
              : item.responseMessage.substring(0, 3) === "Agr"
              ? "Agreement Extension Fees"
              : item.responseMessage.substring(0, 3) === "AHP"
              ? "Adjustment Payment"
              : "Other"}
          </span>
        </td>
      );
    },
    displayInstallmentNumber: (item, index) => {
      return (
        <td className="py-2">
          <span>
            {item.paymentComplete === "25"
              ? "First Installment"
              : item.paymentComplete === "50"
              ? "Second Installemnt"
              : item.paymentComplete === "75"
              ? "Third Installment"
              : item.paymentComplete === "100"
              ? "Fourth Installment"
              : ""}
          </span>
        </td>
      );
    },
    viewOnlinePaymentReceipt: (item, index) => {
      return (
        <TableButtonClick
          isDisplayAllow={true}
          isNormallBtn={true}
          buttonName={"View Receipt"}
          color={"info"}
          onClick={() => PaymentStatusViewHanlder(item.responseMessage)}
        />
      );
    },
  };

  const fields = [
    {
      key: "collectionSeason",
      _style: { width: "10%" },
      label: "Collection Season",
    },
    {
      key: "paymentId",
      _style: { width: "10%" },
      label: "MR No",
    },
    {
      key: "districtName",
      _style: { width: "15%" },
      label: TableHeaderSet("District", "districtName"),
    },

    {
      key: "paymentDateFormat",
      label: TableHeaderSet("DateTime (dd/mm/yyyy)", "paymentDateTime"),
    },

    {
      key: "paymentSuccessDateFormat",
      label: TableHeaderSet(
        "Payment Success DateTime (dd/mm/yyyy)",
        "paymentSuccessDate"
      ),
    },
    // {
    //   key: "responseMessage",
    //   _style: { width: "15%" },
    //   label: "Response Message"
    // },
    {
      key: "amount",
      _style: { width: "7.5%" },
      label: TableHeaderSet("Amount", "amount"),
    },
    {
      key: "displayPaymentType",
      label: "Type",
      _style: { width: "10.5%" },
      sorter: false,
      filter: false,
    },
    {
      key: "displayInstallmentNumber",
      label: "Installmant",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "inserdateformat",
      label: TableHeaderSet("Insert DateTime (dd/mm/yyyy)", "insertDateTime"),
    },

    //    {
    //   key: "statusCode",
    //   _style: { width: "15%" },
    //   label: "Status"
    // },
    {
      key: "challanNumber",
      label: TableHeaderSet("Challan No", "challanNumber"),
      _style: { width: "10%" },
    },
    {
      key: "lotNo",
      _style: { width: "7.5%" },
      label: "Lot No",
    },
    {
      key: "mobile",
      _style: { width: "7.5%" },
      label: "Mobile",
    },
    {
      key: "companyName",
      _style: { width: "15%" },
      label: "Company Name",
    },
    // {
    //   key: "lotId",
    //   _style: { width: "15%" },
    //   label: TableHeaderSet("Lot Id", "lotId"),
    // },
    {
      key: "viewOnlinePaymentReceipt",
      label: "View Receipt",
      _style: { width: "11.5%" },
      sorter: false,
      filter: false,
    },
  ];
  function reset() {
    setpageLimit(0);
    setItemPerPage(10);
  }

  const PaymentTypeList = [
    { value: "--1", label: "Security Deposit" },
    { value: "--3", label: "Additional Security Deposit" },
    { value: "--4", label: "Additional Security Deposit 40%" },
    { value: "--5", label: "Additional Security Deposit 60%" },
    { value: "LT-", label: "Lot Payment" },
    { value: "--2", label: "Full Lot Payment" },
    { value: "FT-", label: "Lot Transfer Fees" },
    { value: "Tra", label: "Security Deposit - Transferred" },
    { value: "--6", label: "Godown Qutity Differnce Amount" },
    { value: "GR-", label: "Godown Rent" },
    { value: "GRE", label: "Godown Rent Fee Extension" },
    { value: "Agr", label: "Agreement Extension Fees" },
    { value: "LFT", label: "Lot Left Fees" },
    { value: "AHP", label: "Adjustment Payment" },
  ];

  const getTenderCollectionSeasonDrop = async () => {
    await apiCallResponse(`Tender/GetTenderCollectionSeason`).then((res) => {
      debugger;
      if (res.success) setItemsCollectionSeason(res.data);
      else setItemsCollectionSeason([]);
    });
  };

   const handleChangeTenderCollectionSeason = (e) => {
    const value = e.target.value;
    updateSearch(e, "tenderNo", "");

  };


  const searchControl = (
    <>

 <SCSelect
        labelname="Collection Season "
        name="CollectionSeason"
        value={search.CollectionSeason}
        onChange={updateSearch}
         items={itemsCollectionSeason.map((item, key) => ({
            value: item.collectionSeason,
            label: item.collectionSeason,
          }))}
      />

      <SCInput
        label="MR No :"
        name={"MRNO"}
        value={search.MRNO}
        onChange={updateSearch}
      />
      <SCInput
        label="Challan No :"
        name={"ChallanNo"}
        value={search.ChallanNo}
        onChange={updateSearch}
      />
      <SCInput
        label="Lot No :"
        name={"LotNo"}
        value={search.LotNo}
        onChange={updateSearch}
      />
      <SCInput
        label="Mobile :"
        name={"Mobile"}
        value={search.Mobile}
        onChange={updateSearch}
      />
      <SCInput
        label="Company Name :"
        name={"CompanyName"}
        value={search.CompanyName}
        onChange={updateSearch}
      />
      <SCSelect
        labelname="Payment Type "
        name="PaymentType"
        value={search.PaymentType}
        onChange={updateSearch}
        items={PaymentTypeList}
      />

      <SCDate
        label="Start Date"
        name={"StartInsertDate"}
        value={search.StartInsertDate}
        onChange={updateSearch}
        maxDate={search.EndInsertDate}
      />
      <SCDate
        label="End Date"
        name={"EndInsertDate"}
        value={search.EndInsertDate}
        onChange={updateSearch}
        minDate={search.StartInsertDate}
      />
    </>
  );

  const additional = (
    <CommonSearchExtra
      isClear={isClear}
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearchButton}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isExportToExcelDisplay={true}
      isExporting={isExporting}
      isDisabledExport={usersData && usersData.length > 0 ? false : true}
      ExportToExcel={ExportToExcel}
    />
  );

  return (
    <CRow>
      <CCol xl={12}>
        <CommonList
          items={usersData}
          fields={fields}
          listName="Online Payment Report"
          loading={loading}
          path="/edituser/"
          additional={additional}
          prev={prevButton}
          next={nextButton}
          disabledprev={disabledprev}
          disablednext={disablednext}
          tabBtn="Edit"
          id="userid"
          scopedSlots={scopedSlotsList}
        />
      </CCol>
    </CRow>
  );
};

export default OnlinePaymentReport;
